import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    format: { default: 'date', type: String },
  }

  connect() {
    this.element.innerHTML = this.#formattedDate()
  }

  #formattedDate() {
    const date = new Date(this.element.dateTime)

    switch (this.formatValue) {
      case 'date':
        return date.toLocaleDateString()

      case 'time':
        return date.toLocaleTimeString()

      case 'datetime':
      default:
        return date.toLocaleString()
    }
  }
}
